import apolloClient from "../apolloClient";
import { CREATE_CHECKOUT, UPDATE_CHECKOUT, GET_CHECKOUT } from "./graphql";
import {
	mapCartToCreateCheckoutInput,
	mapToCreateShippingRateInput,
	mapToCheckoutModel,
	mapToUpdateCheckoutInput,
	mapToCreatePaymentMethodInput,
} from "./helper";

class CheckoutService {
	async create(model, customerId) {
		const { data } = await apolloClient.mutate({
			mutation: CREATE_CHECKOUT,
			variables: {
				checkout: mapCartToCreateCheckoutInput(model, customerId),
			},
		});
		const { checkoutLineItems, ...checkout } = data.updateCart.checkout;
		return {
			...checkout,
			checkoutLineItems: checkoutLineItems.nodes,
		};
	}

	async update(checkout) {
		const { data } = await apolloClient.mutate({
			mutation: UPDATE_CHECKOUT,
			variables: { checkout: mapToUpdateCheckoutInput(checkout) },
		});
		return data.updateCheckout;
	}

	async createShippingRate(checkoutId, shippingRate) {
		const { data } = await apolloClient.mutate({
			mutation: UPDATE_CHECKOUT,
			variables: {
				checkout: mapToCreateShippingRateInput(checkoutId, shippingRate),
			},
		});
		return data.updateCheckout;
	}

	async completedCheckout(checkout) {
		const { data } = await apolloClient.mutate({
			mutation: UPDATE_CHECKOUT,
			variables: {
				checkout: mapToCreatePaymentMethodInput(checkout),
			},
		});
		return data.updateCheckout;
	}

	async fetch(checkoutId) {
		const { data } = await apolloClient.query({
			query: GET_CHECKOUT,
			variables: { checkoutId },
		});
		return mapToCheckoutModel(data.checkout, checkoutId);
	}
}

export default new CheckoutService();
